import React from 'react';
import generalStyle from '../../assets/styles/generalStyle.module.scss';

export const Content = props => {
    return <div>{props.children}</div>;
};

export const GroupButtons = props => {
    const { main, secondary, rest } = props;
    return (
        <>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <div className={'col-sm-7 col-sm-offset-3'}>
                        <div className={generalStyle['button-inline-block']}>
                            {main}
                        </div>
                        {secondary}
                    </div>
                </div>
            </div>
            {rest && (
                <div className={`${generalStyle['secondary-button']} row`}>
                    <div className={'col-sm-7 col-sm-offset-3'}>{rest}</div>
                </div>
            )}
        </>
    );
};

export const Filters = props => {
    return (
        <>
            <Content>{props.children}</Content>
            <ErrorInsideForms error={props.error} />
            <GroupButtons {...props} />
        </>
    );
};

export const ErrorInsideForms = props => {
    return (
        <div className={`${generalStyle['content-margin-bottom']} row`}>
            <div className="col-sm-12">
                <div className={'col-sm-7 col-sm-offset-3'}>
                    {props.children}
                </div>
            </div>
        </div>
    );
};
